// Gets the count of an attribute from a list of Design items.
export default (name, items) => {
  const getCount = (acc, cv) => {
    const att = cv.attributes.find(a => a.name === name && a.value === 'Yes');
    if (att) {
      return acc + 1;
    }
    return parseInt(acc);
  };

  return items.reduce((a, c) => getCount(a, c), 0);
};
